module.exports = __webpack_public_path__ + "img/nav-item-active.8037edea.png";